export default __webpack_public_path__ + "static/media/lulu-briggs.2f5ba49c.png";